export default "__VITE_PUBLIC_ASSET__94216215__"